import apiInstance from "@/axios";

// inapi 발송 경로 스위치 API(서티라이프 관리자 전용). 바꿀 때 inapi 가 변경 이력(이전 → 새, 바꾼 사람)을 남긴다.
export const serviceRouteApi = {
  // { switches: [{ key, route, modifyAt, updatedBy }], history: [{ key, before, after, byName, byUsername, at }] }
  list() {
    return apiInstance.get("/bizmsg/route-switches");
  },

  save(key, route) {
    return apiInstance.put(`/bizmsg/route-switches/${key}`, { route });
  },
};
